import React from "react";
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

export default function Options101Page() {
  return (
    <div className="bg-[#0b0d2a] text-white">
      {/* Hero Section */}
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="h-[300px] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
        <h1 className="text-white text-4xl font-bold">Option 101</h1>
      </div>

      {/* Topic Section */}
      <div className="py-12 px-4 max-w-4xl mx-auto">
        {[
          "What are options",
          "Types of options",
          "Options strategies",
        ].map((title, idx) => (
          <div key={idx} className="flex items-center gap-4 mb-8">
            <img
              src="/photo/graph-thumbnail.jpg"
              alt="thumbnail"
              className="w-[150px] rounded-md"
            />
            <a href={`/options/${title.toLowerCase().replace(/\s+/g, '-')}`}><h2 className="text-2xl text-blue-500 font-semibold">{title}</h2></a>
          </div>
        ))}
      </div>
    </div>
  );
}
